import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';
import Button from '../../components/elements/Button/Button';
import ButtonFileInput from '../../components/elements/ButtonFileInput/ButtonFileInput';
import ButtonLink from '../../components/elements/ButtonLink';
import LoadingBars from '../../components/elements/LoadingBars';
import styles from './styles.scoped.css';
import { Card, Modal, Stack, Text } from '@mantine/core';
import IconUnduh from '../../components/icons/IconUnduh';


export function FormSettingBulk({
  change = () => { },
  handleSubmit = () => { },
  _handleBack = () => { },
  _handleDownload = () => { }
}) {
  const [error, setError] = useState({});
  const [file, setFile] = useState({});
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);

  const { dataTemplateHet, dataUploadUpdatePrice,
    messageUploadUpdatePrice, isLoadingTemplateHet,
    isLoadingUploadUpdatePrice } = useSelector((s) => s.prices);

  const clearErrors = () => {
    setError({});
  };

  let bodyFormData = new FormData();

  const handleRemoveFormData = () => {
    setFile({});
  };

  const handleChangeFile = (name, val) => {
    const modPayload = { file: val };
    Object.keys(modPayload).forEach((val) => {
      bodyFormData.append(name, modPayload[val]);
    });
    setFile(bodyFormData);
  };

  useEffect(() => {
    change('file', file);
  }, [file]);

  const handleIsValid = () => {
    if (
      file instanceof FormData &&
      Object.keys(error).length === 0 &&
      isLoadingUploadUpdatePrice !== true
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (dataUploadUpdatePrice?.success && !isLoadingUploadUpdatePrice) {
      setModalSuccess(true);
    } else if (messageUploadUpdatePrice !== '' && !isLoadingUploadUpdatePrice) {
      setModalError(true);
    }
  }, [isLoadingUploadUpdatePrice, dataUploadUpdatePrice]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={styles['top-content-upload-reg-container']}>
          <div className={styles['left-content-upload-reg']}>
            <h4>
              Pilih file dengan format .xlsx untuk ubah harga dalam jumlah
              banyak
            </h4>
            <br />
            <br />
          </div>
          <div className={styles['right-content-upload-reg']}>
            <img
              className={styles['illustration-upload']}
              src="assets/illu-registrasi-pangkalan.svg"
            />
          </div>
        </div>
        <div className={styles['row']}>
          <ButtonFileInput
            clearErrors={clearErrors}
            deleteFile={handleRemoveFormData}
            errors={error.file}
            extensionAllowed={['xlsx']}
            handleChangeFile={handleChangeFile}
            name="file"
            noBase64={true}
            outlined={true}
            setError={setError}
            sizeValidation={{ kbsize: 1000000 }}
          >
            Pilih File
          </ButtonFileInput>
          {isLoadingUploadUpdatePrice && (
            <div style={{ marginLeft: '10px' }}>
              <LoadingBars size={1} />
            </div>
          )}
        </div>
        <hr />
        <div>
          <h5>Cara Tambah Sekaligus: {isLoadingTemplateHet}</h5>
          <ol className={styles['step-upload-xlsx-regist-bulk']}>
            <li style={{ marginTop: '1rem' }}>
              Unduh file Excel{' '}
              <a
                download
                href={isLoadingTemplateHet ? undefined : dataTemplateHet?.link?.data?.fileUrl}
                style={{
                  color: isLoadingTemplateHet ? '#CCCCCC' : '#0F6EB5',
                  cursor: 'pointer',
                  fontWeight: 700,
                }}
              >
                di sini.
              </a>
            </li>
            <li style={{ marginTop: '1rem' }}>Atur harga eceran tertinggi.</li>
            <li style={{ marginTop: '1rem' }}>
              Unggah kembali file yang sudah diisi.
            </li>
          </ol>
        </div>
        <br />
        <div className={styles['action-btn-container']}>
          <ButtonLink
            className={styles['action-btn-back']}
            outlined={true}
            to={'/price'}
          >
            Kembali
          </ButtonLink>
          <Button
            className={styles['action-btn-continue']}
            disabled={handleIsValid()}
            type="submit"
          >
            Unggah
          </Button>
        </div>
      </form>

      <Modal
        centered
        onClose={() => setModalError(false)}
        opened={modalError}
        size={'lg'}
        withCloseButton={true}
      >
        <Stack align="center" spacing="md">
          <Text fw={500} size={'xl'}>Harga HET Wilayah Gagal Diubah</Text>
          <div className={styles['line']} />
          <Text align="center" c={'#52575C'}>Koreksi daftar wilayah yang dengan harga HET yang gagal diubah. Klik tombol di bawah untuk melihat daftar wilayah yang perlu dikoreksi.</Text>
          <Card align="center" radius={'xl'} style={{ border: '1px solid #FF711A' }} w={'100%'} withBorder>
            <Text fw={500} mb={8}>Daftar Wilayah HET Gagal Diubah</Text>
            <Button icon={<IconUnduh fill={'#FFFFFF'} height={16} width={16} />} onClick={_handleDownload} style={'blue'}>
              Download Error Log
            </Button>
          </Card>
          <Button fullWidth onClick={_handleBack} outlined style={'blue'} >
            Tutup
          </Button>
        </Stack>
      </Modal >
      <Modal
        centered
        onClose={() => setModalSuccess(false)}
        opened={modalSuccess}
      >
        <Stack align="center" spacing="md">
          <Text fw={500}>Unggah Berhasil</Text>
          <Button fullWidth onClick={_handleBack} style={'blue'} >
            Oke
          </Button>
        </Stack>
      </Modal>

    </>
  );
}

FormSettingBulk.propTypes = {
  _handleBack: PropTypes.func,
  _handleDownload: PropTypes.func,
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'bulk-update-price',
  initialValues: {
    file: [],
  },
})(FormSettingBulk);
